import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { PolicyTypeText, PolicyPatternText, PolicyPattern, PolicyType } from './newDistributionList';
import { IPSService } from '@/services/ipsServices';
import IPSDialog from '@/views/components/picker/dialog';
import DialogFactory from '@/views/components/picker/dialogFactory';

@DialogFactory
@Component({
  mixins: [],
  components: {},
})
export default class NewDistributionAdd extends IPSDialog {
  policyId = 0;

  disabled = false;

  title = '添加分销策略';

  sgId = null;

  modeType = null; // 云商城 2 镜像店 1

  data = {
    policyName: '',
    policyType: 0,
    policyPattern: 0,
    tagName: '',
  };

  rules = {
    policyName: [{ required: true, message: '请输入策略名称', trigger: ['blur', 'change'] }],
    policyType: [{ required: true, message: '请选择策略类型', trigger: ['blur', 'change'] }],
    policyPattern: [{ required: true, message: '请选择分佣模式', trigger: ['blur', 'change'] }],
    tagName: [{ required: true, message: '请输入角色标签', trigger: ['blur', 'change'] }],
  };

  policyPatternList = [PolicyPatternText[1]];

  confirmloading = false;

  width = '600px';

  mounted() {
    this.data.policyPattern = this.policyPatternList[0].value;
  }

  onSave() {
    IPSService.newDistributionSave({
      postParams: {
        sgId: Number.parseInt(this.sgId),
        policyName: this.data.policyName,
        policyType: this.data.policyType,
        policyPattern: this.data.policyPattern,
        tagName: this.data.tagName,
      },
    })
      .then((result) => {
        this.$emit('result', {
          policyId: result.policyId,
          policyType: this.data.policyType,
          policyPattern: this.data.policyPattern,
        });
        this.$emit('hidden');
      })
      .catch(() => {
        this.confirmloading = false;
      });
  }

  onChange(val) {
    switch (val) {
      case PolicyType.customer:
        this.policyPatternList = [PolicyPatternText[1]];
        this.data.policyPattern = this.policyPatternList[0].value;
        break;
      case PolicyType.emp:
      case PolicyType.guider:
        // //云商城 员工和导购模式下，去除业绩模式(又加上了2022.4.7)
        // if (this.modeType == 2) {
        //   this.policyPatternList = [...PolicyPatternText].filter((v) => {
        //     return v.text != "业绩模式";
        //   });
        // } else {
        this.policyPatternList = [...PolicyPatternText];
        // }

        break;
      default:
        break;
    }
  }

  beforeConfirm() {
    this.confirmloading = true;
    (this.$refs.form as any).validate((result) => {
      if (result) {
        this.onSave();
      } else {
        this.confirmloading = false;
      }
    });
  }

  renderContent(h) {
    return (
      <el-form props={{ model: this.data }} show-message={false} ref="form" class="r-ma-20" label-position={'left'} rules={this.rules} label-width={'100px'}>
        <el-form-item prop="policyName" label="策略名称">
          <el-input v-model={this.data.policyName} maxlength={20} show-word-limit style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item prop="policyType" label="策略类型">
          <el-radio-group v-model={this.data.policyType} onChange={this.onChange.bind(this)}>
            {PolicyTypeText.map((v, i) => {
              return (
                <el-radio label={v.value} key={i}>
                  {v.text}
                </el-radio>
              );
            })}
          </el-radio-group>
          <div class="tip line-height-14 r-pt-4">
            <span class="text-red">*&nbsp;</span>策略类型修确定不可修改,请谨慎操作
          </div>
        </el-form-item>
        <el-form-item prop="policyPattern" label="分佣模式">
          <el-radio-group v-model={this.data.policyPattern}>
            {this.policyPatternList.map((v, i) => {
              return [
                <el-radio class="r-mr-12" label={v.value} key={i}>
                  {v.text}
                </el-radio>,
                <el-tooltip effect="light" class="r-mr-16" content={v.info} placement="top">
                  <i class="iconfont iconzhushi font-size-14"></i>
                </el-tooltip>,
              ];
            })}
          </el-radio-group>

          <div class="tip line-height-14 r-pt-4">
            <span class="text-red">*&nbsp;</span>策略类型确定后不可修改,请谨慎操作
          </div>
        </el-form-item>
        <el-form-item prop="tagName" label="角色标签">
          <el-input v-model={this.data.tagName} maxlength={6} show-word-limit style="width: 100%"></el-input>
          <div class="tip line-height-14 r-pt-12">
            <span class="text-red">*&nbsp;</span>
            角色标签用于标识适用于当前分销策略的分销员角色身份，如“直营导购”、“合作网红”等；
          </div>
        </el-form-item>
      </el-form>
    );
  }
}
